module.exports = __webpack_public_path__ + "static/media/adesivo_fricke.845c8e74.png";